<section class="product-gallery" aria-label="Product images" [attr.aria-busy]="busy || loading">
  <div class="gallery-toolbar">
    <p *ngIf="editable">Reordering and default selection save immediately. Use Save to update a name.</p>
    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="refresh()" [disabled]="busy || loading">Refresh images</button>
  </div>
  <p *ngIf="!productId">Save the product before adding images.</p>
  <p *ngIf="loading" role="status">Loading images…</p>
  <p *ngIf="busy" role="status">Working…</p>
  <p *ngIf="message" role="status" class="text-success">{{message}}</p>
  <dw-message *ngIf="error" [message]="{ messageBody: error, severity: 'error', allowClose: false }"></dw-message>
  <p *ngIf="schemaMessage" class="text-warning">{{schemaMessage}}</p>
  <div class="gallery-cards">
    <article *ngFor="let row of rows; index as i; trackBy: trackRow" class="image-card"
      (dragover)="overCard($event)" (drop)="dropCard($event, i)">
      <div class="image-preview">
        <app-fitness-media-image *ngIf="imageId(row)" [mediaId]="imageId(row)" [alt]="row.MediaName || productName"
          [width]="320" [height]="210" maxWidth="100%" maxHeight="210px"></app-fitness-media-image>
        <span *ngIf="!imageId(row)" class="text-muted">No image</span>
      </div>
      <div class="card-content">
        <div class="order-tools">
          <button type="button" class="btn btn-light btn-sm drag-handle" [draggable]="!locked && permissions.CanUpdate"
            (dragstart)="startDrag($event, row)" (dragend)="draggedId = 0" [disabled]="locked || !permissions.CanUpdate"
            [attr.aria-label]="'Drag ' + row.MediaName + ' to reorder'" title="Drag to reorder"><i class="fa fa-grip-vertical" aria-hidden="true"></i></button>
          <span>Image {{i + 1}}</span>
          <button type="button" class="btn btn-light btn-sm" (click)="move(i, i - 1)" [disabled]="locked || !permissions.CanUpdate || i === 0"
            [attr.aria-label]="'Move ' + row.MediaName + ' earlier'">←</button>
          <button type="button" class="btn btn-light btn-sm" (click)="move(i, i + 1)" [disabled]="locked || !permissions.CanUpdate || i === rows.length - 1"
            [attr.aria-label]="'Move ' + row.MediaName + ' later'">→</button>
        </div>
        <label [for]="'product-media-name-' + row.ProductMediaId">Media name</label>
        <div class="name-editor">
          <input #nameInput class="form-control" [id]="'product-media-name-' + row.ProductMediaId" [value]="row.MediaName"
            [maxLength]="nameMaxLength" [disabled]="locked || !permissions.CanUpdate" (keydown.enter)="$event.preventDefault(); saveName(row, nameInput.value)">
          <button type="button" class="btn btn-outline-primary btn-sm" [disabled]="locked || !permissions.CanUpdate"
            (click)="saveName(row, nameInput.value)" [attr.aria-label]="'Save name for image ' + (i + 1)">Save</button>
        </div>
        <label class="default-choice"><input #defaultInput type="checkbox" [checked]="row.IsDefault"
          [disabled]="locked || !permissions.CanUpdate" (change)="setDefault(row, defaultInput.checked)"> Default image</label>
        <div class="image-actions" *ngIf="editable">
          <button type="button" class="btn btn-outline-secondary btn-sm" (click)="replace(row)"
            [disabled]="locked || !permissions.CanUpdate || !hasMediaId || !webImageTypeId">Replace</button>
          <button type="button" class="btn btn-outline-danger btn-sm" (click)="remove(row)"
            [disabled]="locked || !permissions.CanDelete">Remove</button>
        </div>
      </div>
    </article>
  </div>
  <p *ngIf="productId && !loading && !rows.length">No product images yet.</p>
  <div *ngIf="editable && permissions.CanCreate" class="upload-zone" [class.drop-active]="dropActive"
    (dragover)="overUpload($event)" (dragleave)="dropActive = false" (drop)="dropFiles($event)">
    <i class="fa fa-images" aria-hidden="true"></i>
    <p>Drop images here or choose files to open the upload dialog.</p>
    <button type="button" class="btn btn-primary" (click)="upload()" [disabled]="!canUpload">Choose files</button>
  </div>
</section>


